import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import { DEFAULT_BUSINESS_TIMEZONE } from "@/lib/constants/timezones"

dayjs.extend(utc)
dayjs.extend(timezone)

export function resolveBusinessTimezone(setting?: string | null): string {
  const trimmed = setting?.trim()
  if (!trimmed) return DEFAULT_BUSINESS_TIMEZONE
  try {
    if (dayjs.tz(new Date(), trimmed).isValid()) return trimmed
  } catch {
    // fall through
  }
  return DEFAULT_BUSINESS_TIMEZONE
}

/** ISO 8601 with offset for API (wall clock in business timezone). */
export function wallClockToIso(day: string, time: string, tz: string): string {
  if (!day || !time) return ""
  const normalized = /^\d{2}:\d{2}$/.test(time) ? `${time}:00` : time
  return dayjs.tz(`${day} ${normalized}`, "YYYY-MM-DD HH:mm:ss", tz).format()
}

export function businessTodayKey(tz: string): string {
  return dayjs().tz(tz).format("YYYY-MM-DD")
}

export function isSlotInPastBusiness(
  slotTime: string,
  selectedDate: string,
  tz: string,
): boolean {
  const todayInTz = businessTodayKey(tz)
  if (selectedDate !== todayInTz) return false
  const slotInstant = dayjs.tz(
    `${selectedDate} ${slotTime}`,
    "YYYY-MM-DD HH:mm",
    tz,
  )
  return slotInstant.isBefore(dayjs().tz(tz))
}

export function formatWallClockDateTime(
  dateStr: string,
  timeStr: string,
  tz: string,
): string {
  const match = timeStr.match(/^(\d{1,2}):(\d{2})/)
  if (!dateStr || !match) return "--"
  const dt = dayjs.tz(`${dateStr} ${match[0]}`, "YYYY-MM-DD HH:mm", tz)
  if (!dt.isValid()) return "--"
  return new Intl.DateTimeFormat("en-NG", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: tz,
  }).format(dt.toDate())
}

export function formatIsoInBusinessTz(iso: string, tz: string): string {
  const dt = dayjs(iso)
  if (!dt.isValid()) return "--"
  return new Intl.DateTimeFormat("en-NG", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: tz,
  }).format(dt.toDate())
}
